export default __webpack_public_path__ + "static/media/fr-asia-5.57b48cf7.jpg";